import { adminFetch, buildListParams, normalizeList } from "./_client";
import type { AdminListParams, AdminListResponse, AdminSuggestion, SuggestionDetail, SuggestionHistoryEntry, CancelDeclineReason } from "./types";


export async function fetchAdminSuggestions(token: string, params: AdminListParams = {}): Promise<AdminListResponse<AdminSuggestion>> {
  const sp = buildListParams(params);
  const raw = await adminFetch<Record<string, unknown>>(`/admin/suggestions?${sp}`, token);
  return normalizeList<AdminSuggestion>(raw, "suggestions");
}


export function fetchAdminSuggestion(token: string, id: number) {
  return adminFetch<{ suggestion: SuggestionDetail; history: SuggestionHistoryEntry[] }>(`/admin/suggestions/${id}`, token);
}


export function suggestionAction(token: string, id: number, action: "approve" | "decline" | "expire", reason?: string) {
  return adminFetch<{ success: boolean; action: string; status: string }>(`/admin/suggestions/${id}/action`, token, {
    method: "POST",
    body: JSON.stringify({ action, reason }),
  });
}


export function fetchCancelDeclineReasons(token: string, appliesTo?: string) {
  const params = new URLSearchParams();
  if (appliesTo) params.set("applies_to", appliesTo);
  return adminFetch<{ reasons: CancelDeclineReason[] }>(`/admin/cancel-decline-reasons?${params}`, token);
}


export function createCancelDeclineReason(token: string, reason: string, applies_to: "cancel" | "decline" | "withdrawal", details_required = false) {
  return adminFetch<CancelDeclineReason>("/admin/cancel-decline-reasons", token, {
    method: "POST",
    body: JSON.stringify({ reason, applies_to, details_required }),
  });
}


export function updateCancelDeclineReason(token: string, id: number, updates: Partial<CancelDeclineReason>) {
  return adminFetch<CancelDeclineReason>(`/admin/cancel-decline-reasons/${id}`, token, {
    method: "PUT",
    body: JSON.stringify(updates),
  });
}


export function reorderCancelDeclineReasons(token: string, orderedIds: number[]) {
  return adminFetch<{ success: boolean; reasons: CancelDeclineReason[] }>("/admin/cancel-decline-reasons/reorder", token, {
    method: "PUT",
    body: JSON.stringify({ orderedIds }),
  });
}


export function deleteCancelDeclineReason(token: string, id: number) {
  return adminFetch<{ success: boolean }>(`/admin/cancel-decline-reasons/${id}`, token, {
    method: "DELETE",
  });
}
